import { PropsWithChildren, useCallback } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { FilterQueryContextProvider } from 'src/contexts/FilterQueryContext';
import { ReportMetricsContextProviderV2 } from 'src/contexts/ReportMetricsContext/ReportMetricsContextV2';
import { ReportConfigV2 } from 'src/hooks/reportConfigs';
import { EmptyReportV2TicketGroupQuery } from 'src/utils/eventQueryUtils';
import {
  ReportV2Client,
  UIReportV2TicketGroupQuery,
} from 'src/WebApiController';

export function ReportsTicketGroupContextProviderV2({
  reportConfig,
  isExport,
  children,
}: PropsWithChildren<{
  reportConfig: ReportConfigV2;
  isExport?: boolean;
}>) {
  const { activeAccountWebClientConfig } = useAppContext();

  const getReportMetrics = useCallback(
    (
      tempReportConfig: ReportConfigV2,
      filters: UIReportV2TicketGroupQuery,
      pageNumber: number
    ) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getTicketGroupReportMetrics({
        ...tempReportConfig.request,
        pageNumber,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  const getReportMetricsSummary = useCallback(
    (tempReportConfig: ReportConfigV2, filters: UIReportV2TicketGroupQuery) => {
      return new ReportV2Client(
        activeAccountWebClientConfig
      ).getTicketGroupReportSummary({
        ...tempReportConfig.request,
        filters,
      });
    },
    [activeAccountWebClientConfig]
  );

  return (
    <FilterQueryContextProvider<UIReportV2TicketGroupQuery>
      initialQuery={
        (reportConfig.request.filters ||
          EmptyReportV2TicketGroupQuery) as UIReportV2TicketGroupQuery
      }
      emptyQuery={EmptyReportV2TicketGroupQuery}
      loadQueryFromUrl={false}
    >
      <ReportMetricsContextProviderV2<UIReportV2TicketGroupQuery>
        queryKey="getReportTicketGroupMetricsV2"
        getReportMetrics={getReportMetrics}
        getReportMetricsSummary={getReportMetricsSummary}
        disabled={isExport}
        reportConfig={reportConfig}
      >
        {children}
      </ReportMetricsContextProviderV2>
    </FilterQueryContextProvider>
  );
}
